import PriorityHighOutlinedIcon from '@mui/icons-material/PriorityHighOutlined';
import { fillRed } from '../../utils/contrastSvgAttributes';

const PriorityMediumIcon: React.FC = () => {
  return <PriorityHighOutlinedIcon fontSize="small" style={{ width: '0.8em', color: fillRed }} />;
};

export default PriorityMediumIcon;
